import React from "react";

function AllLeads() {
  return <div>AllLeads</div>;
}

export default AllLeads;
